import React from "react";
import { SectionTitle } from "./section-title";
import { useId } from "../../../hooks/use-id";

export const BenefitsSection = () => {
	const images = [
		{
			src: "/img/piloto-rnbp/beneficio1.png",
			alt: "Acceso durante 12 meses a la plataforma de lectura MakeMake"
		},
		{
			src: "/img/piloto-rnbp/beneficio2.png",
			alt: "Capacitación especializada sobre el uso de libros digitales para la promoción de lectura"
		},
		{
			src: "/img/piloto-rnbp/beneficio3.png",
			alt: "Certificado de participación"
		},
		{
			src: "/img/piloto-rnbp/beneficio4.png",
			alt: "Participación en los eventos virtuales especiales de promoción de lectura y de capacitación de la plataforma MakeMake"
		}
	];

	const titleRegionId = useId('beneficios');
	return (
		<section aria-labelledby={titleRegionId} className="p-3">
			<SectionTitle title="Beneficios" labelId= {titleRegionId}/>

			<div className="row p-3 pt-5 justify-content-center align-items-center"  style={{background:'url(/img/backs/books.svg)'}}>
				{images.map((image, index) => (
					<div key={index} className="d-flex justify-content-center align-items-center col-12 col-sm-6 col-lg-3 p-2 overflow-hidden" >
						<img className="img-fluid" src={image?.src} alt={image?.alt || ''} style={{borderRadius:'.5rem'}}/>
					</div>
				))}
			</div>
		</section>
	);
};
